import React from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import cardone from './cardone.png'
import cardtwo from './cardtwo.png'
import cardthree from './cardthree.png'
import cardfour from './cardfour.png'
const Earnings = () => {
    return (

        <div className="">
            <div className='position-relative' style={{ backgroundImage: `url(https://res.cloudinary.com/dextrzp2q/image/fetch/f_webp/q_60,w_${window.innerWidth},h_${window.innerHeight}/https://img.freepik.com/free-vector/abstract-background-with-pink-purple-flowing-lines-design_1048-20364.jpg?t=st=1743033102~exp=1743036702~hmac=b10f2e0856ce6c240b75c65af8044f7a15f20335d40393ec94fa8ef830ab4dca&w=900)`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
                <div style={{ zIndex: '20' }} className='shade'></div>
                <div style={{ zIndex: '30' }} className='position-relative'>
                    <div className="container-fluid py-5">
                        <div className="px-md-5">
                            <div className="px-3">
                                <div className="row py-5">
                                    <div className="col-md-6 col-12">
                                        <h1 className="text-light">How Can You Earn with VTC?
                                        </h1>
                                        <h5 className="text-light">VTC provides four powerful income streams that allow you to earn daily profits, team bonuses, and high-value rewards. Here’s how you can make money with KGC:

                                        </h5>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-md-end col-md-6 col-12 px-md-5">
                                        <div className="px-md-5">
                                            {/* <p className="text-light">A Smarter, More Profitable Way to Invest in Your Financial Future!</p> */}
                                            <button className="btn btn-light">Join Our Community</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="container-fluid">
                                <div className="row" >
                                    <div
                                        className="col-md-3 col-12 my-2 " data-aos="zoom-in-up" data-aos-duration="1000"

                                    >
                                        <div
                                            className="border-0 card text-light rounded-4 h-100 overflow-hidden"
                                            style={{
                                            
                                                backgroundColor: "rgba(0, 0, 0, 0.7)"
                                            }}
                                        >
                                            <img
                                                src={cardone}
                                                className="card-img-top"
                                               
                                            />
                                            <div className="card-body justify-content-start d-flex flex-column">
                                                <h2 className="my-2 py-2 card-title h5">
                                                Daily Staking Rewards
                                                </h2>
                                                <p className="card-text">
                                                You can enjoy a 0.4% daily profit on your staked investment. This income is completely passive, requiring no trading or effort.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="col-md-3 col-12 my-2 " data-aos="zoom-in-up" data-aos-duration="1000"

                                    >
                                        <div
                                            className="border-0 card text-light rounded-4 h-100 overflow-hidden"
                                            style={{
                                            
                                                backgroundColor: "rgba(0, 0, 0, 0.7)"
                                            }}
                                        >
                                            <img
                                                src={cardtwo}
                                                className="card-img-top"
                                                
                                            />
                                            <div className="card-body justify-content-start d-flex flex-column">
                                                <h2 className="my-2 py-2 card-title h5">
                                                Direct Referral Income
                                                </h2>
                                                <p className="card-text">
                                                It allows you to earn a commission every time you bring in a new investor. The more people you refer, the higher your earnings. There are no limits on referrals, meaning your income potential is endless.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="col-md-3 col-12 my-2 " data-aos="zoom-in-up" data-aos-duration="1000"

                                    >
                                        <div
                                            className="border-0 card text-light rounded-4 h-100 overflow-hidden"
                                            style={{
                                            
                                                backgroundColor: "rgba(0, 0, 0, 0.7)"
                                            }}
                                        >
                                            <img
                                                src={cardthree}
                                                className="card-img-top"
                                            
                                            />
                                            <div className="card-body justify-content-start d-flex flex-column">
                                                <h2 className="my-2 py-2 card-title h5">
                                                Level Income
                                                </h2>
                                                <p className="card-text">
                                                Team Level Income provides an opportunity to earn up to 50% commission from your team’s investments. The larger your team grows, the bigger your rewards.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="col-md-3 col-12 my-2 " data-aos="zoom-in-up" data-aos-duration="1000"

                                    >
                                        <div
                                            className="border-0 card text-light rounded-4 h-100 overflow-hidden"
                                            style={{
                                            
                                                backgroundColor: "rgba(0, 0, 0, 0.7)"
                                            }}
                                        >
                                            <img
                                                src={cardfour}
                                                className="card-img-top"
                                               
                                            />
                                            <div className=" card-body  d-flex flex-column">
                                                <h2 className="my-2 py-2 card-title h5">
                                                Leadership Bonus
                                                </h2>
                                                <p className="card-text">
                                                Leaders earn additional rewards and incentives, including cash bonuses, luxury gifts, and exclusive trips, as they advance in rank.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="col-md-3 col-12 my-2 " data-aos="zoom-in-up" data-aos-duration="1000"

                                    >
                                        
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    )
}

export default Earnings